export default class DadosDasDespesas {

    constructor(formulario = '') {
        this.incluirJurosSobreDespesasNaCompraAnimaisRecriaEngorda = formulario.incluirJurosSobreDespesasNaCompraAnimaisRecriaEngorda == undefined ? "Não" : formulario.incluirJurosSobreDespesasNaCompraAnimaisRecriaEngorda;
        this.taxaJurosDespesasCompraAnimaisRecriaEngorda = formulario.taxaJurosDespesasCompraAnimaisRecriaEngorda == undefined ? 0 : formulario.taxaJurosDespesasCompraAnimaisRecriaEngorda;
        this.incluirJurosSobreDemaisDespesas = formulario.incluirJurosSobreDemaisDespesas == undefined ? "Não" : formulario.incluirJurosSobreDemaisDespesas;
        this.taxaJurosDemaisDespesas = formulario.taxaJurosDemaisDespesas == undefined ? 0 : formulario.taxaJurosDemaisDespesas;
    }
}